import React from "react";

import Link from "@busbud/design-system-components/dist/Link";

import { useAppContext } from "@app/helpers/hooks";
import { clickedDownloadTickets } from "@app/tracking/account-tracking";

import { useScript } from "../../helpers/use-script";

interface Props {
  ticket_id: number;
  transit_object_jwt: string;
  onError: (error?: unknown) => void;
  size?: "matchparent";
  height?: "standard" | "small";
  className?: string;
}
export const GooglePayTicket: React.FC<Props> = ({
  transit_object_jwt,
  ticket_id,
  onError,
  size,
  className,
  height
}) => {
  useScript("https://apis.google.com/js/platform.js", () => {
    window.gapi.savetoandroidpay.render(`gpt-${ticket_id}`, {
      jwt: transit_object_jwt,
      onfailure: onError,
      size,
      height
    });
  });

  return <div id={`gpt-${ticket_id}`} className={className}></div>;
};

interface GooglePayTicketImageProps {
  transit_object_jwt: string;
  className?: string;
  tracker_name?: string;
}

export const GooglePayTicketImage: React.FC<GooglePayTicketImageProps> = ({
  transit_object_jwt,
  className,
  tracker_name
}) => {
  const { translator, urlBuilder, locale, tracker } = useAppContext();
  return (
    <Link
      href={`https://pay.google.com/gp/v/save/${transit_object_jwt}`}
      target="_blank"
      rel="noreferrer"
      onClick={() =>
        tracker.track(clickedDownloadTickets(tracker_name || "google_wallet"))
      }
    >
      <img
        alt={translator.t("!download-tickets.google-pay-pass")}
        src={urlBuilder.saveToGooglePayButton(locale)}
        className={className}
      />
    </Link>
  );
};
